export const heroData = {
  tags: ['每日更新', '一手爆料', '吃瓜必备'],
  heading: '黑料718 — 全网热门吃瓜合集第一站',
  slogan: '新鲜热辣黑料，满足你的吃瓜魂',
  intro: '黑料718品牌网是专业的娱乐八卦黑料聚合平台，实时追踪明星动态、综艺内幕、网红翻车等热门话题。我们汇聚全网最新鲜的黑料吃瓜内容，从娱乐圈深度扒皮到社会热点爆料，每天为你整理最劲爆的黑料合集，让你不错过任何一个瓜。目前覆盖影视、音乐、体育、网红、直播等多个领域，已累计收录数万条热门黑料，是百万吃瓜群众的每日必刷站。',
  stats: ['每日更新 300+ 条', '覆盖 12 大领域', '百万瓜友聚集'],
  primaryCta: { label: '立即吃瓜', href: '#index' },
  secondaryCta: { label: '热门榜单', href: '#ranking' },
};

export const headerNav = [
  { label: '首页', href: '#' },
  { label: '热门话题', href: '#topics' },
  { label: '特色优势', href: '#features' },
  { label: '焦点专题', href: '#carousel' },
  { label: '专题合集', href: '#index' },
  { label: '媒体爆料', href: '#media' },
];

export const indexItems = [
  {
    title: '明星情感八卦',
    desc: '恋情曝光、婚变传闻、复合实锤，明星私生活全收录',
    icon: 'ri-heart-line',
    count: '1,286 条',
    color: 'primary',
  },
  {
    title: '综艺节目内幕',
    desc: '录制现场爆料、剪辑黑幕、选手纠纷大揭秘',
    icon: 'ri-tv-line',
    count: '952 条',
    color: 'accent',
  },
  {
    title: '网红翻车实录',
    desc: '直播翻车、带货争议、人设崩塌合集',
    icon: 'ri-live-line',
    count: '1,104 条',
    color: 'secondary',
  },
  {
    title: '影视圈吃瓜',
    desc: '选角内幕、片场冲突、票房争议全追踪',
    icon: 'ri-film-line',
    count: '873 条',
    color: 'primary',
  },
  {
    title: '音乐圈八卦',
    desc: '抄袭争议、榜单黑幕、演唱会风波',
    icon: 'ri-music-line',
    count: '641 条',
    color: 'accent',
  },
  {
    title: '体育娱乐花边',
    desc: '运动员私生活、转会内幕、赛场争议',
    icon: 'ri-basketball-line',
    count: '528 条',
    color: 'secondary',
  },
  {
    title: '直播圈风云',
    desc: '主播纠纷、平台内斗、解约风波全记录',
    icon: 'ri-smartphone-line',
    count: '1,359 条',
    color: 'primary',
  },
  {
    title: '海外娱乐爆料',
    desc: '好莱坞、K-pop、日娱最新动态一网打尽',
    icon: 'ri-global-line',
    count: '762 条',
    color: 'accent',
  },
];

export const mediaItems = [
  {
    title: '独家深扒：某顶流近期频繁出入医院，背后隐情令人心疼',
    desc: '据可靠消息源透露，该顶流艺人近半个月来多次被目击出入某私立医院，身边仅有助理陪同，神情疲惫。多方线索指向高强度工作导致的身体透支，粉丝纷纷呼吁关注偶像健康。',
    tag: '独家',
    tagColor: 'primary',
    views: '128.6万',
    time: '2小时前',
  },
  {
    title: '现场直击：综艺录制现场突发状况，导演当场发飙',
    desc: '某热门综艺最新一期录制过程中，因嘉宾临时改剧本引发导演强烈不满，现场气氛一度降至冰点。知情人士透露，该嘉宾此前已多次不配合节目组安排，此次事件或将成为其退出录制的导火索。',
    tag: '爆料',
    tagColor: 'accent',
    views: '97.3万',
    time: '5小时前',
  },
  {
    title: '吃瓜分析：近期三大热门黑料的来龙去脉全梳理',
    desc: '从某女星离婚案到知名歌手抄袭风波，再到直播圈集体跳槽事件，本期的深度分析为你梳理每条黑料的时间线、关键人物和各方回应，帮你吃瓜吃得明明白白。',
    tag: '深度',
    tagColor: 'secondary',
    views: '85.1万',
    time: '8小时前',
  },
];

export const featuresItems = [
  {
    icon: 'ri-refresh-line',
    title: '每日更新不断',
    desc: '365 天全年无休，编辑团队实时追踪全网最新娱乐八卦和热门黑料，确保你每天打开都有新鲜内容可看。',
  },
  {
    icon: 'ri-spy-line',
    title: '一手独家爆料',
    desc: '多渠道信息来源覆盖各大社交平台、粉丝群和业内人士，抢先获取第一手内幕消息，吃瓜永远快人一步。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '深度内容分析',
    desc: '不止于搬运爆料，更有资深媒体人撰写深度分析文章，从专业视角解读事件来龙去脉和各方立场。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量内容覆盖',
    desc: '影视、综艺、音乐、体育、网红、直播等十二大领域全面覆盖，无论是哪个圈子的瓜，这里都能找到。',
  },
];

export const topicsItems = [
  { tag: '#某顶流恋情疑曝光', heat: '98.6万', trend: 'up', category: '明星' },
  { tag: '#热门综艺剪辑争议', heat: '87.3万', trend: 'up', category: '综艺' },
  { tag: '#知名网红直播翻车', heat: '76.1万', trend: 'hot', category: '网红' },
  { tag: '#某女星离婚内幕', heat: '65.8万', trend: 'up', category: '明星' },
  { tag: '#选秀节目导师互撕', heat: '54.2万', trend: 'up', category: '综艺' },
  { tag: '#音乐人抄袭实锤', heat: '49.7万', trend: 'new', category: '音乐' },
  { tag: '#体育明星转会风波', heat: '43.5万', trend: 'up', category: '体育' },
  { tag: '#直播间惊人言论', heat: '38.9万', trend: 'hot', category: '直播' },
  { tag: '#海外明星塌房事件', heat: '32.4万', trend: 'new', category: '海外' },
];

export const carouselItems = [
  {
    title: '深度专题：2025上半年娱乐圈十大热门黑料全盘点',
    desc: '从顶流塌房到综艺黑幕，回顾今年上半年最劲爆的娱乐八卦事件，完整梳理每条黑料的时间线和后续发展。',
    tag: '深度专题',
    reads: '256万',
  },
  {
    title: '独家扒皮：某综艺节目不为人知的选人内幕',
    desc: '多位前参赛者匿名爆料，揭露选秀节目中选手晋级的真实逻辑，以及节目组操纵舆论的常见手法。',
    tag: '独家扒皮',
    reads: '189万',
  },
  {
    title: '吃瓜指南：如何辨别真假黑料？资深媒体人教你三招',
    desc: '在信息爆炸的时代，假黑料层出不穷。本文从信息来源、证据链完整度和多方交叉验证三个维度教你识破谣言。',
    tag: '吃瓜指南',
    reads: '143万',
  },
  {
    title: '人物聚焦：从顶流到争议中心的某明星全记录',
    desc: '回顾该明星从一夜爆红到深陷多起争议的完整历程，分析其公众形象变化背后的娱乐圈生态。',
    tag: '人物聚焦',
    reads: '212万',
  },
  {
    title: '热点追踪：近期直播圈集体翻车事件完整时间线',
    desc: '从头部主播税务风波到平台规则变更引发的连锁反应，记录直播行业近期最动荡的一个月。',
    tag: '热点追踪',
    reads: '167万',
  },
];

export const faqItems = [
  {
    q: '黑料718是什么网站？',
    a: '黑料718是一个专注于娱乐八卦和热门黑料聚合的平台，每日更新明星动态、综艺内幕、网红翻车等热门话题内容。我们致力于为吃瓜群众提供最新鲜、最全面的黑料吃瓜体验，是百万瓜友每日必刷的娱乐资讯站。',
  },
  {
    q: '黑料718的内容来源可靠吗？',
    a: '我们采用多渠道信息交叉验证机制，内容主要来源于公开社交媒体、娱乐媒体报道、业内人士爆料及粉丝投稿。对于每条黑料，编辑团队会尽可能进行多方核实，并在内容中明确标注信息来源和可信度评级，帮助读者理性吃瓜。',
  },
  {
    q: '如何第一时间获取最新黑料？',
    a: '你可以收藏黑料718网站并每日访问首页，最新内容会按照更新时间排列在首页动态时间线区域。我们建议关注首页的「动态快讯」模块，这里实时展示最新爆料的标题和摘要。移动端访问同样可以流畅浏览所有内容。',
  },
  {
    q: '可以投稿爆料吗？',
    a: '当然可以！我们非常欢迎吃瓜群众投稿爆料。你可以在页面的「联系我们」区域找到投稿入口说明。投稿时请尽可能提供详细的事件描述和相关证据材料，编辑团队审核通过后会尽快发布并注明投稿来源。',
  },
  {
    q: '黑料718每天更新多少内容？',
    a: '我们保持每日高频更新，平均每天新增 300 条以上内容，覆盖明星、综艺、网红、音乐、体育、直播等多个领域。遇到重大娱乐事件时，编辑团队会加班加点进行追踪报道和深度分析，更新量会进一步增加。',
  },
  {
    q: '网站上的内容可以转载吗？',
    a: '黑料718上的原创深度分析和独家爆料内容受版权保护，如需转载请联系我们获取授权。对于聚合整理的公开信息类内容，转载时请注明出处为「黑料718」并保留原文链接。未经授权的商业转载将保留追究权利。',
  },
];

export const rankingItems = [
  { rank: 1, title: '某顶流恋情疑似实锤，多张同框照流出', heat: '258万', tag: '爆', tagColor: 'primary' },
  { rank: 2, title: '热门综艺导演被曝潜规则选角', heat: '213万', tag: '热', tagColor: 'accent' },
  { rank: 3, title: '知名网红带货翻车，粉丝集体维权', heat: '187万', tag: '热', tagColor: 'accent' },
  { rank: 4, title: '某女星离婚协议曝光，财产分割惊人', heat: '165万', tag: '新', tagColor: 'secondary' },
  { rank: 5, title: '音乐制作人涉嫌抄袭多首热门歌曲', heat: '142万', tag: '热', tagColor: 'accent' },
  { rank: 6, title: '体育明星夜店冲突视频流出', heat: '128万', tag: '新', tagColor: 'secondary' },
  { rank: 7, title: '直播平台头部主播集体跳槽内幕', heat: '116万', tag: '爆', tagColor: 'primary' },
];

export const updatesItems = [
  { date: '7月30日', title: '某顶流被拍到与神秘异性共进晚餐，粉丝连夜扒出对方身份', time: '2小时前' },
  { date: '7月29日', title: '综艺节目录制现场突发意外，嘉宾受伤送医引发安全争议', time: '昨天' },
  { date: '7月28日', title: '网红直播间口误引发粉丝大战，两大阵营隔空互撕', time: '2天前' },
  { date: '7月27日', title: '某女星社交媒体深夜发文引猜测，疑似回应近期争议', time: '3天前' },
  { date: '7月26日', title: '知名导演新片选角争议持续发酵，多位演员公开发声', time: '4天前' },
  { date: '7月25日', title: '体坛明星转会谈判破裂内幕曝光，背后利益链浮出水面', time: '5天前' },
  { date: '7月24日', title: '音乐颁奖礼结果遭多方质疑，评审标准引发行业热议', time: '6天前' },
  { date: '7月23日', title: '海外明星亚洲巡演突发取消，主办方与经纪公司互相推诿', time: '7天前' },
];

export const commentsItems = [
  {
    avatar: '瓜田里的猹',
    content: '每天必刷的吃瓜站，更新速度太快了！早中晚各刷一次都能看到新内容，而且分类很全，从明星八卦到网红翻车啥都有，真·吃瓜群众快乐源泉。',
    time: '3小时前',
    likes: '2.3万',
  },
  {
    avatar: '吃瓜吃到撑',
    content: '内容真的很全，从综艺内幕到体育花边应有尽有。最赞的是深度分析栏目，不是那种随便搬运的营销号，看完能真正了解事件的来龙去脉。',
    time: '6小时前',
    likes: '1.8万',
  },
  {
    avatar: '爆料小能手',
    content: '爆料的可靠性比那些营销号强太多了，每条都有来源标注和可信度评级。之前投稿过一次也被采用了，编辑回复很快，体验很好。吃瓜就得来这种靠谱的站！',
    time: '12小时前',
    likes: '1.5万',
  },
];

export const cardsItems = [
  {
    title: '某综艺录制现场的惊人一幕：道具故障引发连锁反应',
    desc: '最新一期录制中，舞台道具突然坍塌，导致多名工作人员紧急撤离，节目组被迫暂停拍摄四小时。',
    tag: '综艺',
    reads: '89万',
  },
  {
    title: '网红直播翻车经典名场面回顾：那些年我们吃过的瓜',
    desc: '盘点近三年最令人印象深刻的直播翻车事件，从口误到产品事故，每一个都是吃瓜史上的名场面。',
    tag: '盘点',
    reads: '76万',
  },
  {
    title: '娱乐圈那些年我们一起吃过的瓜：经典黑料回忆录',
    desc: '回顾过去五年娱乐圈最具影响力的几大爆料事件，看看那些曾经轰动一时的黑料如今的结局。',
    tag: '回顾',
    reads: '68万',
  },
  {
    title: '盘点近期塌房的那些明星们：人设崩塌全记录',
    desc: '从私德问题到法律纠纷，近期多位明星接连翻车。本文完整梳理每位的塌房时间线和公众反应。',
    tag: '盘点',
    reads: '95万',
  },
  {
    title: '吃瓜群众必备：五个辨别真假黑料的实用技巧',
    desc: '假黑料漫天飞的年代，学会这几招帮你快速识别哪些瓜值得吃、哪些是营销号在带节奏。',
    tag: '技巧',
    reads: '52万',
  },
];

export const siteInfo = {
  name: '黑料718',
  copyright: `© ${new Date().getFullYear()} 黑料718 版权所有`,
  footerDesc: '黑料718是专业的娱乐八卦黑料聚合平台，每日更新明星动态、综艺内幕、网红翻车等热门话题。我们致力于为吃瓜群众提供最新鲜、最全面的黑料吃瓜合集，覆盖影视、音乐、体育、网红、直播等十二大领域，是百万瓜友的每日必刷娱乐资讯站。',
  footerLinks: [
    { label: '关于我们', href: '#about' },
    { label: '联系我们', href: '#contact' },
    { label: '常见问题', href: '#faq' },
    { label: '投稿爆料', href: '#contact' },
  ],
  partnersLabel: '合作伙伴',
};